



















































































import { Component, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { Apis, Factories } from '@finx/web-repository'
import StoreRelatorios from '@/store/Relatorios'

@Component

export default class ViewRelatorioDetalhes extends Vue {
  loadings: any = {
    getRelatorio: false,
  }

  relatorios: any[] = []

  showRelatoriosFiltros: Boolean = false

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  get profissionalExecutante(): any {
    return StoreRelatorios.getters.PROFISSIONAL_EXECUTANTE
  }

  mounted() {
    this.getRelatorio()
  }

  back() {
    window.history.back()
  }

  async getRelatorio() {
    const routeParams = this.$route.params

    const params: any = {
      fontePagadora: routeParams.fontePagadoraId,
      operadoraId: routeParams.operadoraId,
      initialDate: routeParams.initialDate,
      finalDate: routeParams.finalDate,
      localExecucaoId: routeParams.localExecucaoId,
    }

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) params.prestadorId = this.prestador.id

    const hasProfissionalExecutante = Object.keys(this.profissionalExecutante).length > 0
    if (hasProfissionalExecutante) params.profissionalExecutanteId = this.profissionalExecutante.id

    switch (routeParams.type) {
      case 'fonte-pagadora':
        this.getRelatorioFontePagadora(params)
        break

      case 'operadora':
        this.getRelatorioOperadora(params)
        break

      default:
        break
    }
  }

  async getRelatorioFontePagadora(params) {
    this.loadings.getRelatorio = true

    const request = await Apis.Legacy.Relatorios.getDetalheRelatorioFontePagadora(params)
    const success = Factories.Apis.success(request)

    if (success) {
      const producao = request.data.data
      this.relatorios = this.prepareProducao(producao)
    }

    this.loadings.getRelatorio = false
  }

  async getRelatorioOperadora(params) {
    this.loadings.getRelatorio = true

    const request = await Apis.Legacy.Relatorios.getDetalheRelatorioOperadora(params)
    const success = Factories.Apis.success(request)

    if (success) {
      const producao = request.data.data
      this.relatorios = this.prepareProducao(producao)
    }

    this.loadings.getRelatorio = false
  }

  prepareProducao(producao) {
    // @ts-ignore
    let dataRealizacao = _.sortBy(producao, 'dataRealizacao')
    // @ts-ignore
    dataRealizacao = _.groupBy(dataRealizacao, 'dataRealizacao')

    return producao
  }

  print() {
    window.print()
  }
}
